import React, { useState, useEffect } from 'react'
import axios from 'axios'
import '../../../styles/FormHorairesTarifs.css'
import MenuAdmin from './MenuAdmin'

const EditeurHorairesTarifs = () => {
  const [données, setDonnées] = useState(null)

  // Charger les données depuis le fichier JSON
  useEffect(() => {
    fetch('./json/HorairesTarifs.json')
      .then((response) => response.json())
      .then((data) => setDonnées(data))
  }, [])

  // Fonction pour sauvegarder les données sur le serveur.
  const sauvegarderDonnees = async () => {
    const nomFichier = 'HorairesTarifs.json'
    const cheminFichier = '../json'
    // console.log(données)

    // Vérification des données
    if (!données) {
      alert('Aucune donnée à enregistrer.')
      return
    }

    try {
      // Convertir les données en chaîne JSON

      const donneesJson = JSON.stringify(données, null, 2)
      // console.log('donneesJson = ', donneesJson)

      const response = await axios.post(
        // Appel vers le serveur PHP local (Développement)
        // 'http://localhost:8000/enregistrejson_v2.php',
        // Appel vers le serveur (Production)
        './php/enregistrejson_v2.php',
        {
          nomFichier,
          cheminFichier,
          donneesJson,
        }
      )

      // Vérifier le statut de la réponse
      if (response.data && response.data.success) {
        alert('Les données ont bien été enregistrées.')
      } else {
        alert(
          response.data && response.data.message
            ? response.data.message
            : "Les données n'ont pas été enregistrées."
        )
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement du fichier:", error)
      alert("Une erreur est survenue lors de l'enregistrement des données.")
    }
  }

  // Fonction pour sauvegarder les données en téléchargeant le fichier json
  // const sauvegarderDonnees = () => {
  //   const blob = new Blob([JSON.stringify(données, null, 2)], {
  //     type: 'application/json',
  //   })
  //   const url = URL.createObjectURL(blob)
  //   const a = document.createElement('a')
  //   a.href = url
  //   a.download = 'HorairesTarifs.json'
  //   a.click()
  // }

  // Fonction pour ajouter une ligne de cours
  const ajouterLigneCours = (indexJour) => {
    const nouveauxCours = [...données.cours]
    nouveauxCours[indexJour].horaires.push({ heure: '', description: '' })
    setDonnées({ ...données, cours: nouveauxCours })
  }

  // Fonction pour supprimer une ligne de cours
  const supprimerLigneCours = (indexJour, indexHoraire) => {
    const nouveauxCours = [...données.cours]
    nouveauxCours[indexJour].horaires.splice(indexHoraire, 1)
    setDonnées({ ...données, cours: nouveauxCours })
  }

  // Fonction pour mettre à jour une ligne de cours
  const mettreÀJourLigneCours = (indexJour, indexHoraire, champ, valeur) => {
    const nouveauxCours = [...données.cours]
    nouveauxCours[indexJour].horaires[indexHoraire][champ] = valeur
    setDonnées({ ...données, cours: nouveauxCours })
  }

  // Fonction pour ajouter une ligne de tarif
  const ajouterLigneTarif = () => {
    setDonnées({
      ...données,
      tarifs: [...données.tarifs, { duree: '', seul: '', couple: '' }],
    })
  }

  // Fonction pour supprimer une ligne de tarif
  const supprimerLigneTarif = (index) => {
    const nouveauxTarifs = [...données.tarifs]
    nouveauxTarifs.splice(index, 1)
    setDonnées({ ...données, tarifs: nouveauxTarifs })
  }

  // Fonction pour mettre à jour une ligne de tarif
  const mettreÀJourLigneTarif = (index, champ, valeur) => {
    const nouveauxTarifs = [...données.tarifs]
    nouveauxTarifs[index][champ] = valeur
    setDonnées({ ...données, tarifs: nouveauxTarifs })
  }

  // Fonction pour ajouter un jour après un jour spécifique
  const ajouterJour = (indexJour) => {
    const nouveauxCours = [...données.cours]
    nouveauxCours.splice(indexJour + 1, 0, {
      jour: 'Nouveau Jour',
      professeur: '',
      horaires: [],
    })
    setDonnées({ ...données, cours: nouveauxCours })
  }

  // Fonction pour supprimer un jour
  const supprimerJour = (indexJour) => {
    const nouveauxCours = [...données.cours]
    nouveauxCours.splice(indexJour, 1)
    setDonnées({ ...données, cours: nouveauxCours })
  }

  // Si données est null (ou undefined), le composant retourne un message de chargement à la place du rendu normal.
  if (!données) return <div>Chargement...</div>

  return (
    <div id="formHorairesTarifs" className="formHorairesTarifs">
      <MenuAdmin />
      <div
        id="texte-FormHorairesTarifs"
        className="containerTexteHorairestarifs"
      >
        {/* Affichage des données et boutons d'édition */}
        <div id="text_HorairesTarifs-titre" className="">
          <div
            id="saison"
            className="saison"
            contentEditable
            onBlur={(e) =>
              setDonnées({ ...données, saison: e.target.innerText })
            }
          >
            SAISON {données.saison}
          </div>
          <div
            id="dateDemarrage"
            className="dateDemarrage"
            contentEditable
            onBlur={(e) =>
              setDonnées({ ...données, dateDemarrage: e.target.innerText })
            }
          >
            {données.dateDemarrage}
          </div>
        </div>

        {/* Tableaux de cours */}
        {données.cours.map((jour, indexJour) => (
          <div key={indexJour}>
            <table className="tableCours">
              <thead>
                <tr>
                  <th colSpan="2" className="th">
                    <div
                      id="lieu"
                      className="lieu"
                      contentEditable
                      onBlur={(e) =>
                        setDonnées({
                          ...données,
                          lieu: { ...données.lieu, nom: e.target.innerText },
                        })
                      }
                    >
                      {données.lieu.nom}
                    </div>
                    <div
                      contentEditable
                      onBlur={(e) =>
                        setDonnées({
                          ...données,
                          lieu: {
                            ...données.lieu,
                            adresse: e.target.innerText,
                          },
                        })
                      }
                    >
                      {données.lieu.adresse}
                    </div>{' '}
                    <a
                      href={données.lieu.lienPlan}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="texteFormHorairesTarifsA"
                    >
                      Plan d'accès
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody className={`${`fondtableau${(indexJour % 3) + 1}`}`}>
                {/* <tbody className="fondtableau1"> */}
                <tr>
                  <td colSpan="2" className="td">
                    <div
                      className="saisieJourProf"
                      contentEditable
                      onBlur={(e) => {
                        const nouveauxCours = [...données.cours]
                        nouveauxCours[indexJour].jour =
                          e.target.innerText.split(' - ')[0]
                        nouveauxCours[indexJour].professeur =
                          e.target.innerText.split(' - ')[1] || ''
                        setDonnées({ ...données, cours: nouveauxCours })
                      }}
                    >
                      {jour.jour} - {jour.professeur}
                    </div>
                  </td>
                </tr>
                {jour.horaires.map((horaire, indexHoraire) => (
                  <tr key={indexHoraire}>
                    <td
                      className="td"
                      contentEditable
                      onBlur={(e) =>
                        mettreÀJourLigneCours(
                          indexJour,
                          indexHoraire,
                          'heure',
                          e.target.innerText
                        )
                      }
                    >
                      {horaire.heure}
                    </td>
                    <td
                      className="td"
                      contentEditable
                      onBlur={(e) =>
                        mettreÀJourLigneCours(
                          indexJour,
                          indexHoraire,
                          'description',
                          e.target.innerText
                        )
                      }
                    >
                      {horaire.description}
                    </td>
                    <td
                      id="celSupprimerLigneJour"
                      className="celSupprimerLigneJour"
                    >
                      <button
                        className="button"
                        onClick={() =>
                          supprimerLigneCours(indexJour, indexHoraire)
                        }
                      >
                        Supprimer
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div id="btSousJour" className="btSousJour">
              <div>
                <button
                  className="button"
                  onClick={() => ajouterLigneCours(indexJour)}
                >
                  Ajouter une ligne
                </button>
              </div>
              <div>
                <button
                  className="button"
                  onClick={() => supprimerJour(indexJour)}
                >
                  Supprimer ce jour
                </button>
                <button
                  className="button"
                  onClick={() => ajouterJour(indexJour)}
                >
                  Ajouter un jour après celui-ci
                </button>
              </div>
            </div>
          </div>
        ))}
        <p
          className="contentEditable"
          id="note1"
          contentEditable
          onBlur={(e) => setDonnées({ ...données, note1: e.target.innerText })}
        >
          {données.note1}
        </p>
        <p
          className="contentEditable fondtableau3"
          id="note2"
          contentEditable
          onBlur={(e) => setDonnées({ ...données, note2: e.target.innerText })}
        >
          {données.note2}
        </p>
        {/* Tableau des tarifs */}
        <table className="tableCours">
          <thead>
            <tr>
              <th
                colSpan="3"
                className="th"
                contentEditable
                onBlur={(e) =>
                  setDonnées({ ...données, titreTarif: e.target.innerText })
                }
              >
                {données.titreTarif}
              </th>
            </tr>
            <tr>
              <th className="th"></th>
              <th className="th">Seul</th>
              <th className="th">Couple</th>
            </tr>
          </thead>
          <tbody>
            {données.tarifs.map((tarif, index) => (
              <tr
                key={index}
                className={`${`fondtableau${index % 2 === 0 ? '1' : '2'}`}`}
              >
                <td
                  className="td dureetarif"
                  contentEditable
                  onBlur={(e) =>
                    mettreÀJourLigneTarif(index, 'duree', e.target.innerText)
                  }
                >
                  {tarif.duree}
                </td>
                <td
                  className="td"
                  contentEditable
                  onBlur={(e) =>
                    mettreÀJourLigneTarif(index, 'seul', e.target.innerText)
                  }
                >
                  {tarif.seul}
                </td>
                <td
                  className="td"
                  contentEditable
                  onBlur={(e) =>
                    mettreÀJourLigneTarif(index, 'couple', e.target.innerText)
                  }
                >
                  {tarif.couple}
                </td>
                <td
                  id="celSupprimerLigneTarif"
                  className="celSupprimerLigneTarif"
                >
                  <button
                    className="button"
                    onClick={() => supprimerLigneTarif(index)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div id="btSousTarif" className="btSousTarif">
          <button
            id="btAjouterLigneTarif"
            className="button"
            onClick={ajouterLigneTarif}
          >
            Ajouter une ligne de tarif
          </button>
        </div>
        <div
          id="text_BLOCK_Tarifs"
          className="block-text-horairestarifs blk-text"
        >
          <p
            className="contentEditable"
            contentEditable
            onBlur={(e) =>
              setDonnées({ ...données, adhesion: e.target.innerText })
            }
          >
            {données.adhesion}
          </p>
          <hr style={{ border: '1px solid red' }} />
          <p
            className="contentEditable"
            contentEditable
            onBlur={(e) =>
              setDonnées({ ...données, paiement1: e.target.innerText })
            }
          >
            {données.paiement1}
          </p>
          <hr style={{ border: '1px solid red' }} />
          <p
            className="contentEditable"
            contentEditable
            onBlur={(e) =>
              setDonnées({ ...données, paiement2: e.target.innerText })
            }
          >
            {données.paiement2}
          </p>
        </div>
        {/* Bouton de sauvegarde */}
        <div id="enregistrer" className="enregistrer">
          <button
            id="btenregistrerHorairesTarifs"
            type="submit"
            className="btenregistrer"
            onClick={sauvegarderDonnees}
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  )
}

export default EditeurHorairesTarifs
